import React, {Fragment, useState} from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    NumberField,
    FunctionField, Filter, ReferenceInput, AutocompleteInput, SelectInput, useLoading, DateInput, ReferenceArrayInput,
    SelectArrayInput, NumberInput,
    useAuthenticated, TextInput
} from 'react-admin';
import {makeStyles} from "@material-ui/core/styles";

import {
    CustomPagination, getMarketColorCode, OrderStatuses, OrderTypes, setCurrentFilters, applyCurrentFilter
} from "../../utilities/Common";

import {Container, LinearProgress, Box, CircularProgress, Button} from "@material-ui/core";
import OrdersExport from "./OrdersExport";
import OrdersListActions from "./OrdersListActions";
import Link from "@material-ui/core/Link";

export const styles = (theme => ({
    root: {},
    loading: {
        '& .MuiTable-root': {
            display: 'none'
        },
        '& .MuiTypography-body2': {
            display: 'none'
        },
        '& .MuiTablePagination-toolbar': {
            display: 'none'
        }

    },
    orderFilter: {
        width: '10em'
    },
    organisationFilter: {
        width: '18em'
    },
    skuFilter: {
        '& .MuiFormHelperText-root.Mui-error': {
            display: 'none'
        },
        minWidth: '8em'
    },
    typeFilter: {
        minWidth: '8em'
    },
    statusFilter: {
        minWidth: '6em'
    },
    stateFilter: {
        '& .MuiFormHelperText-root.Mui-error': {
            display: 'none'
        },
        minWidth: '8em'
    }
}));

const useStyles = makeStyles(styles);

const ListFilters = props => {
    const classes = useStyles();

    // setCurrentFilters(props,
    //     ['id', 'orderType[]', 'toOrganisationId', 'orderStatus[]', 'skuUuid[]',
    //         'createdAt_from_date', 'createdAt_to_date', 'requestedAt_from_date', 'requestedAt_to_date', 'actionedAt_from_date',
    //         'actionedAt_to_date', 'kegsRequestedFrom', 'kegsRequestedTo', 'isExpress', 'state',
    //         'producerLocation', 'origin', 'originLocation', 'shippingMethod'],
    //     'orders');

    return (
        <Filter {...props}>
            <ReferenceInput source="id" reference="orders" label={'Order No.'}
                            className={classes.orderFilter}
                            filter={{market: localStorage.getItem('mId')}}
                            sort={{ field: 'orderId', order: 'desc' }}
                            sortDefaultValues={{ orderId: 'desc'}} alwaysOn resettable allowEmpty={false}>
                <AutocompleteInput optionText="displayId" />
            </ReferenceInput>
            <SelectArrayInput source="orderType" label={'Order Type'}
                              choices={OrderTypes} className={classes.typeFilter} resettable alwaysOn  />
            <ReferenceInput source="toOrganisationId" reference="organisations"
                            filter={{market: localStorage.getItem('mId'), isProducer: 1, isActive: 1}}
                            sort={{ field: 'name', order: 'asc' }}
                            sortDefaultValues={{ field: 'name', order: 'asc' }} label={'Producer'}
                            className={classes.organisationFilter} alwaysOn resettable allowEmpty emptyText={'All'}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <SelectArrayInput source="orderStatus" label={'Status'} choices={OrderStatuses} className={classes.statusFilter} resettable alwaysOn />
            <ReferenceArrayInput source={'skuUuid[]'} reference="skus" label={'Keg Type'}
                                 className={classes.skuFilter} resettable alwaysOn >
                <SelectArrayInput source={'skuUuid[]'} optionText="name" />
            </ReferenceArrayInput>
            <TextInput label={'PO Number'} source={'poNumber'} resettable />
            <DateInput label={'Placed From'} source={'createdAt_from_date'} resettable />
            <DateInput label={'Placed To'} source={'createdAt_to_date'} resettable />
            <DateInput label={'Due Date From'} source={'requestedAt_from_date'} alwaysOn resettable />
            <DateInput label={'Due Date To'} source={'requestedAt_to_date'} alwaysOn resettable />
            <DateInput label={'Actioned From'} source={'actionedAt_from_date'} resettable />
            <DateInput label={'Actioned To'} source={'actionedAt_to_date'} resettable />
            <NumberInput label={'No. of Kegs From'} source={'kegsRequestedFrom'} resettable />
            <NumberInput label={'No. of Kegs To'} source={'kegsRequestedTo'} resettable />
            <SelectInput label={'Next Day Delivery'} source="isExpress" choices={[
                { id: null, name: 'All' },
                { id: 1, name: 'Yes' },
                { id: 0, name: 'No' },
            ]} />
            <ReferenceInput source="state" reference="locations/states" label={'State'} resettable className={classes.stateFilter}
                            filter={{market: localStorage.getItem('mId')}} >
                <SelectArrayInput optionText="stateName" resettable />
            </ReferenceInput>
            <ReferenceInput source="producerLocation" reference="locations"
                            filter={{market: localStorage.getItem('mId')}}
                            sort={{ field: 'name', order: 'asc' }}
                            sortDefaultValues={{ field: 'name', order: 'asc' }} label={'Producer Location'}
                            className={classes.organisationFilter} resettable allowEmpty emptyText={'All'}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput source="origin" reference="organisations"
                            filter={{market: localStorage.getItem('mId')}}
                            label={'Origin'}
                            className={classes.organisationFilter} resettable allowEmpty emptyText={'All'}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <ReferenceInput source="originLocation" reference="locations"
                            filter={{market: localStorage.getItem('mId')}}
                            sort={{ field: 'name', order: 'asc' }}
                            sortDefaultValues={{ field: 'name', order: 'asc' }} label={'Origin Location'}
                            className={classes.organisationFilter} resettable allowEmpty emptyText={'All'}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <SelectInput label={'Shipping Method'} source="shippingMethod" choices={[
                { id: null, name: 'All' },
                { id: 0, name: 'Deliver' },
                { id: 1, name: 'Customer Pick-up' },
                { id: 2, name: 'Freight Delivery' },
            ]} />

        </Filter>
    )
};

const ToOrganisation = ({record}) => {
    return(
        <React.Fragment>
            { record.toOrganisationName ?
                <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/organisations/${record.toOrganisationId}/overview`}>
                    <span style={{fontWeight: 'bold', color: '#1887ad'}}>{record.toOrganisationName}</span>
                </Link>
                : null } <br/>
            { record.toLocationId ?
                <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/organisations/${record.toOrganisationId}/locations/view/${record.toLocationId}`}>
                    <span style={{color: getMarketColorCode(localStorage.getItem('mId')) }}>{record.toLocationName}</span>
                </Link>
                : null }
        </React.Fragment>
    )
}
const FromOrganisation = ({record}) => {
    return(
        <React.Fragment>
            { record.fromOrganisationName ?
                <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/organisations/${record.fromOrganisationId}/overview`}>
                    <span style={{fontWeight: 'bold', color: '#1887ad'}}>{record.fromOrganisationName}</span>
                </Link>
                 : 'Not Allocated' } <br/>
            { record.fromLocationId ?
                <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/organisations/${record.fromOrganisationId}/locations/view/${record.fromLocationId}`}>
                    <span style={{color: getMarketColorCode(localStorage.getItem('mId')) }}>{record.fromLocationName}</span>
                </Link>
                 : null }
        </React.Fragment>
    )
}

const OrdersList = props => {
    useAuthenticated();
    const loading = useLoading();
    const classes = useStyles();
    const marketId = localStorage.getItem('mId');
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const state = { setErrorMessage: setErrorMessage,
                         setSuccessMessage: setSuccessMessage }

    let defaultFilterValues = { market: marketId, tz: Intl.DateTimeFormat().resolvedOptions().timeZone };

    // defaultFilterValues = applyCurrentFilter(defaultFilterValues,
    //     ['id', 'orderType[]', 'toOrganisationId', 'orderStatus[]', 'skuUuid[]',
    //         'createdAt_from_date', 'createdAt_to_date', 'requestedAt_from_date', 'requestedAt_to_date', 'actionedAt_from_date',
    //         'actionedAt_to_date', 'kegsRequestedFrom', 'kegsRequestedTo', 'isExpress', 'state',
    //         'producerLocation', 'origin', 'originLocation', 'shippingMethod'],
    //         'orders');

    return (
        <Fragment>
            <Container maxWidth={false}>
                { loading && <LinearProgress /> }
                { loading &&
                <Box justifyContent={'center'} justifyItems={'center'}  alignItems={'center'} alignContent={'center'}
                     style={{backgroundColor: '#1f2124', color: '#fff', padding:'5px', position: 'fixed',
                         bottom: '0', zIndex: 50, width: '90%'}}>
                    <Box p={1}><CircularProgress size={20} style={{color: '#fff'}} /> Please wait...</Box>
                </Box>
                }
                <List {...props}
                      actions={<OrdersListActions state={state} />}
                      filter={{ market: marketId, tz: localStorage.getItem('timezone') }}
                      filterDefaultValues={defaultFilterValues}
                      filters={ <ListFilters /> }
                      sort={{ field: 'orderId', order: 'desc' }}
                      perPage={10}
                      bulkActionButtons={false}
                      exporter={OrdersExport}
                      pagination={<CustomPagination />}
                >
                    <Datagrid
                        // empty={<Box m={3} textAlign={'center'}> <EmptyRecordIcon /> </Box>}
                    >
                        <FunctionField source={'orderId'} render={record => <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/kegs/orders/${record.orderId}/details`}>
                            <span style={{fontWeight: 'bold', color: '#1887ad'}}>{record.orderId}</span>
                        </Link> } label={'Order Number'} />
                        <FunctionField source={'orderStatus'} render={record => (record.orderStatusText) } label={'Order Status'} />
                        <FunctionField source={'orderType'} render={record => (record.orderTypeText) } label={'Order Type'} />
                        <NumberField source="kegsRequested" label={'No. of Kegs'} />
                        <FunctionField source={'skuId'} render={record => (record.skuName) } label={'Keg Type'} />
                        <FunctionField source={'shippingMethod'} render={record => (record.shippingMethodText) } label={'Shipping Method'} />
                        <FunctionField source={'isExpress'} render={record => (<span>{(record.isExpress) ? 'Yes' : 'No'}</span>) } label={'Next Day Delivery'} />
                        <TextField source="poNumber" label={'PO Number'} />
                        <FunctionField source={'toOrganisationName'} render={record => <ToOrganisation record={record} /> } label={'Producer'} />
                        <FunctionField source={'state'} render={record => (record.toLocationState) } label={'State'} />
                        <FunctionField source={'forecastType'} render={record => (record.forecastTypeText) } label={'Forecast Type'} />
                        <DateField source="createdAt" label={'Placed'} locales={(localStorage.getItem('mId') === '4') ? 'en-US' : 'en-GB'}
                                   options={{ day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }}/>
                        <DateField source="requestedAt" label={'Due Date'} locales={(localStorage.getItem('mId') === '4') ? 'en-US' : 'en-GB'} />
                        <FunctionField source={'fromOrganisationName'} render={record => <FromOrganisation record={record} /> } label={'Origin'} />
                        <FunctionField source={'actionedAt'} render={record =>
                            record.actionedAt
                                ?

                                <DateField source="actionedAt" label={'Actioned'} locales={(localStorage.getItem('mId') === '4') ? 'en-US' : 'en-GB'}
                                           options={{ day: 'numeric', month: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true }} />

                                :

                                (record.orderStatus === 6) ?
                                    <Link href={`${process.env.REACT_APP_TRACKS_PORTAL_URL}/#/kegs/orders/${record.orderId}/modify`}
                                          style={{textDecoration: 'none'}}>
                                        <Button variant={'contained'} size={'small'}>Create Order</Button>
                                    </Link>
                                    : null
                        } label={'Actioned'} />

                    </Datagrid>
                </List>
            </Container>
        </Fragment>
    );

}

export default OrdersList;

